import { useEffect, useState } from "react";
import { Button, Col, notification, Row } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axiosClient from "../../api/axiosClient";
import modifyId from "../../utils/modifyId";
import prepareSlots from "../../utils/prepareSlots";
import handleApiError from "../../utils/handleError";
import { Loading } from "../../components";

export default function AvailbleSlots() {
  const location = useLocation();
  const [datesAndSlots, setDatesAndSlots] = useState<any>({});
  const navigate = useNavigate();
  const params = useParams();
  const [selectedSlot, setSelectedSlot] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const selectedDate = location.state?.selectedDate;
  const slots = location.state?.slots;
  const voucherDetails = location.state?.voucherDetails;

  useEffect(() => {
    setDatesAndSlots(prepareSlots(slots));
  }, [slots, setDatesAndSlots]);

  async function handleScheduleExam() {
    try {
      setLoading(true);
      await axiosClient.post("vouchers/claim", {
        voucher_id: params.id,
        slot: selectedSlot,
      });
      navigate("/my-session");
      notification.success({ message: "Schedule successfully" });
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  }
  return (
    <div className="book_slot_container">
      {loading ? <Loading /> : null}
      <h5>Available Time Slots</h5>

      <div className="book_slot_exam_detail">
        <div className="book_slot_pill">
          <h5>Exam ID</h5>
          <h5>{modifyId(voucherDetails?.exam_id)}</h5>
        </div>
        <div className="book_slot_pill">
          <h5>Exam Name</h5>
          <h5>{voucherDetails?.exam_name}</h5>
        </div>
        <div className="book_slot_pill">
          <h5>Duration</h5>
          <h5>{voucherDetails?.duration} minutes</h5>
        </div>
      </div>

      <div className="book_slot_pill_time_slot_section">
        <div className="book_slot_pill_time_slot_main_container">
          <Row
            align="middle"
            gutter={[30, 30]}
            style={{ marginTop: 40, alignSelf: "flex-start" }}
          >
            <Col>
              <h5 className="book_slot_selected_heading">
                Slots Available on {selectedDate}
              </h5>
            </Col>

            <Col>
              <Button type="primary" onClick={() => navigate(-1)}>
                Change Date
              </Button>
            </Col>
          </Row>
          <div className="book_slot_pill_time_slot_container">
            {datesAndSlots[selectedDate]?.length
              ? datesAndSlots[selectedDate].map(({ time, slot }: any) => (
                  <div
                    className="book_slot_pill_time_slot"
                    aria-checked={slot === selectedSlot}
                    onClick={() => setSelectedSlot(slot)}
                  >
                    <h5>{time}</h5>
                  </div>
                ))
              : null}
          </div>
        </div>
      </div>
      {selectedSlot ? (
        <Row
          justify={"center"}
          style={{ marginTop: 30 }}
          onClick={handleScheduleExam}
        >
          <Button type="primary">Schedule Exam</Button>
        </Row>
      ) : null}
    </div>
  );
}
